import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { EditTableTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<EditTableTheme>;
const css = baseCss as ThemedCssFunction<EditTableTheme>;

export const CustomTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeaderHead = styled.thead`
  top: 0;
  position: sticky;
  z-index: 10;
`;


export const TableHeader = styled.tr`
  background-color: ${(props) => props.theme.mode.EditTable.backgroundColor};
  border-bottom: 2px solid ${(props) => props.theme.mode.EditTable.borderColor || '#ddd'};
`;

export const TableHeaderCell = styled.th`
  text-align: left;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  border-left: 1px solid lightgray;
  color: ${(props) => props.theme.mode.EditTable.textColorLight || '#000'};
`;

export const TableRow = styled.tr<{ isSelected: boolean; isLight: boolean }>`
  position: relative;
  border-bottom: 1px solid ${(props) => props.theme.mode.EditTable.borderColor || '#ddd'};
  background-color: ${(props) => !props.isLight ? props.theme.mode.EditTable.backgroundColorLight || '#fcfcfc' : props.theme.mode.EditTable.backgroundColorDark || '#f6f6f6'};
  &:hover {
    background-color: ${(props) => props.theme.mode.EditTable.hoverBackgroundColor};
  }
  ${(props) => props.isSelected && `
    background-color: ${props.theme.mode.EditTable.selectedBackgroundColor || '#99ddff'};
  `}
`;


export const TableDataCell = styled.td`
  text-align: left;
  padding: 5px 10px 5px 20px;
  border: 1px solid ${(props) => props.theme.mode.EditTable.borderColor};
  &:hover {
    background-color:${(props) => props.theme.mode.EditTable.hoverBckgroundCellColor};
  }
`;

export const ActionsColumn = styled.td`
  min-width: 50px;
  justify-content: center;
  align-items: center;
`;


export const TableHeaderDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80vw;
  font-weight: bold;
  background-color: ${(props) => props.theme.mode.EditTable.backgroundColor || 'transparent'};

`;

export const ConditionalStyledDiv = styled.div<{ shouldApplyLinkDecoration: boolean }>`
  display: inline-block;
  color: ${(props) => props.theme.mode.EditTable.textColor || '#000'};
  ${({ shouldApplyLinkDecoration }) =>
    shouldApplyLinkDecoration &&
    `
    font-weight: bold;
    color: blue;
    width: fit-content;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      font-weight: bold;
      color: blue;
    }
  `}

`;
